export const CHARGEBACK_STATUSES = [
    { id: 'requested',          label: 'Solicitado',             chipVariant: 'alert' },
    { id: 'under_review',       label: 'Em análise',             chipVariant: 'info' },
    { id: 'waiting_documents',  label: 'Aguardando documentos',  chipVariant: 'alert' },
    { id: 'won',                label: 'Ganho',                  chipVariant: 'success' },
    { id: 'lost',               label: 'Perdido',                chipVariant: 'error' },
    { id: 'reversed',           label: 'Revertido',              chipVariant: 'default' },
];

export const CHARGEBACK_STATUS_MAP = Object.fromEntries(
    CHARGEBACK_STATUSES.map(s => [s.id, s])
);
